import { AngularFireAuthModule } from "angularfire2/auth";
import { AngularFireDatabaseModule } from "angularfire2/database";
import { AngularFireModule } from "angularfire2";
import { BrowserModule } from "@angular/platform-browser";
import { Camera } from "@ionic-native/camera";
//import { ClipboardModule } from 'ngx-clipboard';
import { ClipboardModule } from "ngx-clipboard/dist/src";
import { CloudSettings, CloudModule } from "@ionic/cloud-angular";
import { EffectsModule } from "@ngrx/effects";
import { ErrorHandler, NgModule } from "@angular/core";
import { HttpModule } from "@angular/http";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  IonicApp,
  IonicErrorHandler,
  IonicModule,
  DeepLinkConfig
} from "ionic-angular";
import { Pro } from "@ionic/pro";
import { QRCodeModule } from "angular2-qrcode";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StoreModule } from "@ngrx/store";
import { InAppBrowser } from "@ionic-native/in-app-browser";

import { SplashPage } from "../pages/splash/splash";
import { WatanewsPage } from "../pages/watanews/watanews";
import { PayEscrowPage } from "../pages/pay-escrow/pay-escrow";
import { CookiesPage } from "../pages/cookies/cookies";
import { LegalPage } from "../pages/legal/legal";

import { AppComponent } from "./app.component";
import { AppEffects } from "./app.effects";
import { AppUtilities } from "./app.utilities";
import {
  IdolsReducer,
  SettingsReducer,
  TokenReducer,
  UserReducer,
  UsersReducer,
  WalletReducer
} from "./app.reducer";
//import { ChatlistPage } from '../pages/chatlist/chatlist';
//import { ChatPage } from '../pages/chat/chat';
import { ConfirmationPage } from "../pages/confirmation/confirmation";
import { HomePage } from "../pages/home/home";
import { IdolsPage } from "../pages/idols/idols";
import { IdolprofilePage } from "../pages/idolprofile/idolprofile";
import { LoginPage } from "../pages/login/login";
import { EditUserProfilePage } from "../pages/edit-user-profile/edit-user-profile";
import { LoginEmailPage } from "../pages/login-email/login-email";
import { SignupEmailPage } from "../pages/signup-email/signup-email";
import { MarketplacePage } from "../pages/marketplace/marketplace";
import { NodeService } from "../services/node.service";
import { PrivacypolicyPage } from "../pages/privacypolicy/privacypolicy";
import { RankingPage } from "../pages/ranking/ranking";
import { ReceiveautographsPage } from "../pages/receiveautographs/receiveautographs";
import { SettingsPage } from "../pages/settings/settings";
import { StartPage } from "../pages/start/start";
import { StorageService } from "../services/storage.service";
import { TermsofusePage } from "../pages/termsofuse/termsofuse";
import { TokenComponent } from "../components/token/token";
import { TokenPage } from "../pages/token/token";
import { TokeninfoPage } from "../pages/tokeninfo/tokeninfo";
import { TokenofferPage } from "../pages/tokenoffer/tokenoffer";
import { TokenbuyPage } from "../pages/tokenbuy/tokenbuy";
import { TokensendPage } from "../pages/tokensend/tokensend";
import { TokensellPage } from "../pages/tokensell/tokensell";
import { UserdetailPage } from "../pages/userdetail/userdetail";
import { UserprofilePage } from "../pages/userprofile/userprofile";
//import { UserprofileeditPage } from '../pages/userprofileedit/userprofileedit';
import { UserslistPage } from "../pages/userslist/userslist";
import { WalletPage } from "../pages/wallet/wallet";
import { WalletsendPage } from "../pages/walletsend/walletsend";
import { FannelPage } from "../pages/fannel/fannel";
import { FannelDetailPage } from "../pages/fannel-detail/fannel-detail";
import { FannelApplicantsPage } from "../pages/fannel-applicants/fannel-applicants";
import { FannelInfoPage } from "../pages/fannel-info/fannel-info";
import { CommissionsPage } from "../pages/commissions/commissions";
import { ScTermsConditionsPage } from "../pages/sc-terms-conditions/sc-terms-conditions";
import { FannelsListPage } from "../pages/fannels-list/fannels-list";
import { LegalFannelInfoPage } from "../pages/legal-fannel-info/legal-fannel-info";
import { HelpPage } from "../pages/help/help";
import { HelpModalPage } from "../pages/help-modal/help-modal";
import { IdolsListPage } from "../pages/idols-list/idols-list";
import { ProfileComponent } from "../components/profile/profile";

import { WalletService } from "../services/wallet.service";
import { WatacardLoadingSerivce } from "../services/watacard.loading.service";
import { IdolsStorageService } from "../services/idols.storage.service";
import { HomePaginService } from "../services/home.pagin.service";
import { GeneralPaginService } from "../services/general.pagin.service";
import { ConfigService } from "../services/config.service";
import { EscrowService } from "../services/escrow.service";
import { ContractsService } from "./app.contract.service";

import { Firebase } from "@ionic-native/firebase";
import { FcmService } from "../services/fcm.service";
import { FirebaseService } from "../services/firebase.service";

import { AuthService } from "../services/auth.service";

import { NativePageTransitions } from "@ionic-native/native-page-transitions";

import { GoogleAnalytics } from "@ionic-native/google-analytics";

import { IonicStorageModule } from "@ionic/storage";

const firebaseSettings = {
  apiKey: "AIzaSyCzlAIkVLAnxADd8qvkfmqF3p8_G-IQoOs",
  authDomain: "watafan-33650.firebaseapp.com",
  databaseURL: "https://watafan-33650.firebaseio.com",
  projectId: "watafan-33650",
  storageBucket: "watafan-33650.appspot.com",
  messagingSenderId: "225850379201"
};

const cloudSettings: CloudSettings = {
  core: {
    app_id: "c4904f37"
  }
};

const IonicPro = Pro.init("c4904f37", {
  appVersion: "2.0.4"
});

export class IonicProErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    IonicPro.monitoring.handleNewError(err);
  }
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "./assets/i18n/", ".json");
}

export const deepLinkConfig: DeepLinkConfig = {
  links: [{ component: LegalPage, name: "Legal", segment: "legal" }]
};

@NgModule({
  declarations: [
    AppComponent,
    //ChatlistPage,
    //ChatPage,
    ConfirmationPage,
    HomePage,
    IdolsPage,
    IdolprofilePage,
    EditUserProfilePage,
    LoginPage,
    LoginEmailPage,
    SignupEmailPage,
    MarketplacePage,
    PrivacypolicyPage,
    RankingPage,
    ReceiveautographsPage,
    SettingsPage,
    StartPage,
    TermsofusePage,
    TokenPage,
    TokenComponent,
    TokeninfoPage,
    TokenofferPage,
    TokenbuyPage,
    TokensendPage,
    TokensellPage,
    UserdetailPage,
    UserprofilePage,
    //UserprofileeditPage,
    UserslistPage,
    WalletPage,
    WalletsendPage,
    FannelPage,
    FannelDetailPage,
    FannelApplicantsPage,
    FannelInfoPage,
    SplashPage,
    WatanewsPage,
    PayEscrowPage,
    CookiesPage,
    LegalPage,
    CommissionsPage,
    ScTermsConditionsPage,
    FannelsListPage,
    LegalFannelInfoPage,
    HelpPage,
    HelpModalPage,
    IdolsListPage,
    ProfileComponent
  ],
  imports: [
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(firebaseSettings),
    BrowserModule,
    ClipboardModule,
    CloudModule.forRoot(cloudSettings),
    EffectsModule.forRoot([AppEffects]),
    IonicModule.forRoot(
      AppComponent,
      {
        backButtonText: ""
      },
      deepLinkConfig
    ),
    HttpModule,
    QRCodeModule,
    StoreModule.forRoot({
      idols: IdolsReducer,
      settings: SettingsReducer,
      tokens: TokenReducer,
      user: UserReducer,
      users: UsersReducer,
      wallet: WalletReducer
    }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    AppComponent,
    // ChatlistPage,
    //ChatPage,
    ConfirmationPage,
    HomePage,
    IdolsPage,
    IdolprofilePage,
    EditUserProfilePage,
    LoginPage,
    LoginEmailPage,
    SignupEmailPage,
    MarketplacePage,
    PrivacypolicyPage,
    RankingPage,
    ReceiveautographsPage,
    StartPage,
    SettingsPage,
    TermsofusePage,
    TokenPage,
    TokenComponent,
    TokeninfoPage,
    TokenofferPage,
    TokenbuyPage,
    TokensendPage,
    TokensellPage,
    UserdetailPage,
    UserprofilePage,
    // UserprofileeditPage,
    UserslistPage,
    WalletPage,
    WalletsendPage,
    FannelPage,
    FannelDetailPage,
    FannelApplicantsPage,
    FannelInfoPage,
    SplashPage,
    WatanewsPage,
    PayEscrowPage,
    CookiesPage,
    LegalPage,
    CommissionsPage,
    ScTermsConditionsPage,
    FannelsListPage,
    LegalFannelInfoPage,
    HelpPage,
    HelpModalPage,
    IdolsListPage,
    ProfileComponent
  ],
  providers: [
    AppUtilities,
    ConfigService,
    WatacardLoadingSerivce,
    IdolsStorageService,
    HomePaginService,
    GeneralPaginService,
    NativePageTransitions,
    Camera,
    StatusBar,
    StorageService,
    SplashScreen,
    WalletService,
    Firebase,
    FcmService,
    NodeService,
    EscrowService,
    InAppBrowser,
    FirebaseService,
    ContractsService,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AuthService,
    GoogleAnalytics
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts